var map = {
	"./404-dark.svg": "54ef",
	"./coming-soon-dark.svg": "c09f",
	"./error-dark.svg": "e0c1",
	"./forgot-password-v2-dark.svg": "6e2f",
	"./login-v2-dark.svg": "ff0f",
	"./not-authorized-dark.svg": "a357",
	"./register-v2-dark.svg": "99b7",
	"./reset-password-v2-dark.svg": "aed4",
	"./under-maintenance-dark.svg": "189d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67e3";